import React, { useState } from "react";
import RightPanel from "../../../common/RightPanel";
import LocalizedButton from "../../../common/LocalizedButton";
import styles from "../../../../styles/Campaigns/CampaignLogs.module.scss";
import { ENTITY_TYPE_LIST } from "../../../../constants/campaigns";
import LogRenderer from "./view/LogRenderer";

const CampaignLogsView = ({ ...props }) => {
  const { editLog } = props;
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <LocalizedButton text="Button.view" onClick={() => setIsOpen(true)} />
      <RightPanel
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        className={styles.panel}
        showFooter={false}
        header={`${
          ENTITY_TYPE_LIST.find((item) => item.id === editLog.entityType)?.displayName ||
          editLog.entityType
        } Logs`}
      >
        <LogRenderer {...props} />
      </RightPanel>
    </>
  );
};

export default CampaignLogsView;
